// @mui
import { useTheme } from '@mui/material/styles';
import { Box, BoxProps } from '@mui/material';
import React from 'react';

// ----------------------------------------------------------------------

interface Props extends BoxProps {

}

export default function EnterSvg({ sx }: Props) {
  const theme = useTheme();
  const PRIMARY_MAIN = theme.palette.primary.main;

  return (
    <Box sx={{ ...sx }}>
      <svg xmlns="http://www.w3.org/2000/svg" width="100%" height="100%" viewBox="0 0 512 100">
        <g fill={PRIMARY_MAIN} >
            <mask id="mask" >
                <rect x="-6.78" y="-4.21" fill="white" width="100%" height="53.43" fill-opacity="100%"/>
                <circle cx="25.38" cy="22.5" r="15.45" fill="black" fill-opacity="100%"/>
            </mask>
            <rect mask="url(#mask)" width="100%" height="53.43"/>
            <polygon points="26.31,25.07 20.32,31.05 25.67,31.05 34.22,22.5 25.67,13.95 20.32,13.95 26.31,19.93 17.97,19.93 
                17.97,22.5 17.97,25.07 "/>
        </g>
      </svg>
    </Box>
  );
}
